import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { NftMintSteps } from '@app/client';
import { useMintingOverlayStore } from '@app/store/zustand';

import { Loading, LoadingMint, Mint, Minted, MintError, NotVisualized } from './Steps';

export function YatMintFlow({ currentStep }: { currentStep: NftMintSteps }) {
    const { setMintingFailed } = useMintingOverlayStore();
    const [stepToRender, setStepToRender] = useState(NftMintSteps.Loading);

    useEffect(() => {
        setStepToRender(currentStep);
    }, [currentStep]);

    const handleRetry = useCallback(() => {
        setMintingFailed(false);
        setStepToRender(NftMintSteps.Introduction);
    }, [setMintingFailed]);

    const currentStepComponent = useMemo(() => {
        switch (stepToRender) {
            case NftMintSteps.LoadingMint: {
                return <LoadingMint />;
            }
            case NftMintSteps.Error: {
                return <MintError onRetry={handleRetry} />;
            }
            case NftMintSteps.Complete: {
                return <Minted />;
            }
            case NftMintSteps.YatNotVisualized:
            case NftMintSteps.Processing: {
                return <NotVisualized currentStep={stepToRender} key="no-viz-step" />;
            }

            case NftMintSteps.RenameNft:
            case NftMintSteps.NameNft:
            case NftMintSteps.Introduction: {
                return <Mint key="mint-step" currentStep={stepToRender} />;
            }
            default:
            case NftMintSteps.Loading: {
                return <Loading />;
            }
        }
    }, [handleRetry, stepToRender]);

    return <>{currentStepComponent}</>;
}
